import { RECAPTCHA_SITE_KEY } from './constants';

/**
 * Get reCaptcha token.
 */
export const executeRecaptchaToken = async (action) => {
  if (typeof window === 'undefined') {
    return '';
  }

  if (!window.grecaptcha) {
    return '';
  }

  return await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, {
    action,
  });
};
